export default __webpack_public_path__ + "static/media/map.46a5eecb.png";